import { LogLevel } from "msal";
import { LoggingService as CommonLoggingService } from "@merri/common";

export class LoggingService {
  static msalLogFn(level: LogLevel, message: string, containsPii: boolean) {
    LoggingService.log(`MSAL - ${level} - ${message} - ${window.document.location.href}`);
  }

  static log(message: string, ...optionalParams: any[]) {
    CommonLoggingService.log(message, ...optionalParams);
  }
}
